export default __webpack_public_path__ + "static/media/characters_opt_bw.e3d43156.jpg";